// Move approved SKUs into a project — the picker's remaining strings in the portal's four languages (2026-10-21).
// The rest of the screen already reads `st.mv*` keys.
const en = {
  close: 'Close',
  pickCol: 'Pick',
};

const ko = {
  close: '닫기',
  pickCol: '선택',
};

const vi = {
  close: 'Đóng',
  pickCol: 'Chọn',
};

const zh = {
  close: '关闭',
  pickCol: '选择',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "close": "Fermer",
  "pickCol": "Choisir"
};
const ja = {
  "close": "閉じる",
  "pickCol": "選択"
};

const dictionary = { ns: 'xMove', en, ko, vi, zh, fr, ja };

export default dictionary;
